import { IonContent, IonPage, IonSpinner } from "@ionic/react";

import "./finishJourney.css";
import { useEffect, useState } from "react";
import { Preferences } from "@capacitor/preferences";
import { createJourney } from "../../api/journey";
import { Damage } from "../../types/api/damage.types";
import { createDamage } from "../../api/damage";
import { useHistory } from "react-router";

const FinishJourney: React.FC = () => {
  let history = useHistory();

  const dataURLtoFile = (dataUrl: string, filename: string) => {
    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/jpeg";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  };

  useEffect(() => {
    const storeData = async () => {
      const journey = await Preferences.get({ key: "journey" });
      const res = await createJourney(JSON.parse(journey?.value as string));

      if (res) {
        const damages: Damage[] =
          JSON.parse(
            (await Preferences.get({ key: "damages" })).value as string
          ) || [];

        damages.forEach(async (element) => {
          await createDamage({
            ...element,
            journeyId: res.id,
          });
        });
      }

      await Preferences.remove({ key: "damages" });

      history.push(`/inspection/${res?.id}/finish`);
    };
    storeData();
  }, []);

  return (
    <IonPage>
      <div className="FinishJourney">
        <IonSpinner name="crescent"></IonSpinner>
      </div>
    </IonPage>
  );
};

export default FinishJourney;
